import { styled, css } from 'next-yak'

import * as colors from '../../constants/colors'
import * as glyphs from '../../icons/glyphs'

export type CheckmarkStatus = 'error' | 'checked' | 'focused'

type CheckmarkProps = {
  $disabled?: boolean
  $status?: CheckmarkStatus
}

export const Checkmark = styled(glyphs.fill.Check).attrs({ size: 18 })<CheckmarkProps>`
  border-radius: 2px;
  border: 2px solid ${colors.PRIMARY_GREY_500};
  box-sizing: border-box;
  padding: 2px;
  background-color: ${colors.PRIMARY_GREY_000};
  vertical-align: baseline;

  /* override specificity of svg:not([fill]) in reset css */
  && {
    fill: transparent;
  }

  ${({ $status }) => {
    if ($status === 'checked') {
      return css`
        background-color: ${colors.PRIMARY_BLUE_500};
        border-color: ${colors.PRIMARY_BLUE_500};
        /* override specificity of svg:not([fill]) in reset css */
        && {
          fill: ${colors.PRIMARY_GREY_000};
        }
      `
    }
    if ($status === 'error') {
      return css`
        border-color: ${colors.PRIMARY_RED_500};
      `
    }
    if ($status === 'focused') {
      return css`
        border-color: ${colors.PRIMARY_SAND_900};
      `
    }
    return ''
  }};

  ${({ $disabled, $status }) => {
    if ($disabled) {
      return css`
        background-color: ${colors.SECONDARY_GREY_400};
        border-color: ${colors.PRIMARY_GREY_500};
        /* override specificity of svg:not([fill]) in reset css */
        && {
          fill: ${() => ($status !== 'checked' ? 'transparent' : colors.PRIMARY_GREY_500)};
        }
      `
    }
  }};
`
